module.exports = __webpack_public_path__ + "img/ai-input-manual.a5db9546.svg";